// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*header:start*/
header {
  background: #fff;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  position: fixed;
  z-index: 99;
  display: flex;
  justify-content: center;
  transition: all 1s ease-out;
  opacity: 1;
  top: 0;
  left: 0;
  z-index: 99;
}
header .header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  width: 100%;
}
header .header-container .logo {
  display: flex;
  align-items: center;
}
header .header-container .logo .focalx-logo {
  max-width: 240px;
}
header .header-container .logo .jlr-logo {
  border-left: solid 1px #798593;
  margin-left: 16px;
  padding-left: 16px;
  max-width: 45px;
}
header .header-action-buttons {
  position: relative;
}

/*header:end*/
@media only screen and (min-width: 0px) and (max-width: 767px) {
  header .header-container .logo .focalx-logo {
    max-width: 108px;
  }
  header .header-container .logo .jlr-logo {
    width: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.scss"],"names":[],"mappings":"AAAA,eAAA;AACA;EACI,gBAAA;EACA,4CAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AACJ;AAAI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAEN;AADM;EACE,aAAA;EACA,mBAAA;AAGR;AAFQ;EACE,gBAAA;AAIV;AAFQ;EACE,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAIV;AAAI;EACE,kBAAA;AAEN;;AACE,aAAA;AAEA;EAIc;IACI,gBAAA;EAFlB;EAIc;IACI,WAAA;EAFlB;AACF","sourcesContent":["/*header:start*/\r\nheader{\r\n    background: #fff;\r\n    box-shadow: 0 0 10px 2px rgba(0,0,0,.05);\r\n    width: 100%;\r\n    position: fixed;    \r\n    z-index: 99;      \r\n    display: flex;\r\n    justify-content: center;\r\n    transition: all 1s ease-out;\r\n    opacity: 1;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 99;\r\n    .header-container{\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      height: 72px;\r\n      width: 100%;\r\n      .logo{\r\n        display: flex;\r\n        align-items: center;\r\n        .focalx-logo{\r\n          max-width: 240px;\r\n        }\r\n        .jlr-logo{\r\n          border-left: solid 1px #798593;\r\n          margin-left: 16px;\r\n          padding-left: 16px;\r\n          max-width: 45px;\r\n        }\r\n      }\r\n    }  \r\n    .header-action-buttons{\r\n      position: relative;\r\n    }\r\n  }\r\n  /*header:end*/\r\n\r\n  @media only screen and (min-width: 0px) and (max-width: 767px) {\r\n    header{\r\n        .header-container{\r\n            .logo{\r\n                .focalx-logo{\r\n                    max-width: 108px;\r\n                }\r\n                .jlr-logo{\r\n                    width: 80px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
